import { stringify as querystringify } from 'querystringify'
import {
  apiGatewayKey,
  apiGatewayUrl
} from './config'

export const getJobs = opts => {
  const endpoint = `${apiGatewayUrl}/exports/jobs`
  const url = `${endpoint}?${querystringify(opts)}`

  const params = {
    headers: {
      'x-api-key': apiGatewayKey
    }
  }

  return window.fetch(url, params)
    .then(res => res.json())
}

export const getDrivers = opts => {
  const endpoint = `${apiGatewayUrl}/user/drivers`

  const params = {
    headers: {
      'x-api-key': apiGatewayKey
    }
  }

  return window.fetch(endpoint, params)
    .then(res => res.json())
}



// WEBPACK FOOTER //
// ./src/helpers/api.js